import * as React from 'react'
import { Checkbox, Label } from '@/shared/ui'
import { ensureEphemeralPolicy, isRemembered, setRemembered } from '../utils/remember'

type Props = {
  id?: string
  className?: string
  label?: string
  onChange?: (checked: boolean) => void
}

export default function StayLoggedInCheckbox({ id = 'stay-logged-in', className, label = 'Manter conectado', onChange }: Props) {
  const [checked, setChecked] = React.useState<boolean>(() => isRemembered())

  React.useEffect(() => {
    // Apply persistence policy whenever user toggles
    setRemembered(checked)
    ensureEphemeralPolicy(checked)
    // do not auto-uninstall on unmount if unchecked; the util keeps a single global listener
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked])

  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        <Checkbox
          id={id}
          checked={checked}
          onChange={(e) => {
            const next = (e.target as HTMLInputElement).checked
            setChecked(next)
            onChange?.(next)
          }}
        />
        <Label htmlFor={id} className="select-none">
          {label}
        </Label>
      </div>
    </div>
  )
}

